export default __webpack_public_path__ + "static/media/404 Not Found.ea6863db.png";